import { Filter } from 'utils/filter/filter';
import {
    ColumnDefinitionsDictionary,
    isValidColumnDefinition,
} from '@instinet-analytics/semantic-ui-components';

export interface ColumnFilterState<TColumnId extends string> {
    column: TColumnId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    filter: Filter<any>;
}

export type RowFilterSign = 'INCLUDE' | 'EXCLUDE';

export interface RowFilterState {
    rowIds: number[];
    sign: RowFilterSign;
}

export type FilterState<TColumnId extends string> =
    | ColumnFilterState<TColumnId>
    | RowFilterState;

export function isColumnFilter<TColumnId extends string>(
    filter: FilterState<TColumnId>
): filter is ColumnFilterState<TColumnId> {
    return 'column' in filter;
}
export function isRowFilter<TColumnId extends string>(
    filter: FilterState<TColumnId>
): filter is RowFilterState {
    return 'rowIds' in filter;
}

export interface GridFiltersState<TColumnId extends string> {
    filters: FilterState<TColumnId>[];
}

export function isValidColumnFilter<TColumnId extends string>(
    columnDefinitions: ColumnDefinitionsDictionary<TColumnId>,
    f: ColumnFilterState<TColumnId>
) {
    return isValidColumnDefinition(columnDefinitions, f.column);
}
